import React, { Component } from "react";
import { connect } from "react-redux";
//import PropTypes from "prop-types";
import styles from "./Comment.local.scss";
import { fetchComments /*, fetchTopicComments*/ } from "Thunks";
import { resetComments } from "Actions";
import classnames from "classnames";

import CommentList from "./CommentList";
//import MediaInfo from "./MediaInfo";

import CommentPost from "./CommentPost";
//import SocialReaction from "../../Medias/Social/SocialReaction";

class Comments extends Component {
  // static propTypes = {
  //   media: PropTypes.object.isRequired,
  //   size: PropTypes.oneOf(["sm", "lg"]),
  //   onClickSettings: PropTypes.func,
  //   onClickView: PropTypes.func,
  //   onClickSelect: PropTypes.func
  // };

  componentDidMount() {
    this.fetchComments();
  }

  componentDidUpdate(prevProps) {
    const { currentResource, resetComments } = this.props;
    if (currentResource && prevProps.currentResource !== currentResource) {
      resetComments();
      this.fetchComments();
    }
  }

  componentWillUnmount() {
    this.props.resetComments();
  }

  fetchComments() {
    const {
      currentResource,
      fetchComments,
      //fetchTopicComments,
      type
    } = this.props;

    /*type && type === "TOPIC"
      ? fetchTopicComments({
          objectType: "TOPIC",
          objectId: currentResource.id
        })
      : */
    fetchComments({
      objectType: type,
      objectId: currentResource.id
    });
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.currentResource.id === this.props.currentResource.id) {
      return false;
    }
    return true;
  }

  render() {
    let { type, currentResource } = this.props;

    let helpClass = "cell small-3";
    if (type) {
      helpClass += ` comment-${type.toLowerCase()}`;
    }
    return (
      <div
        className={classnames(styles.comment, helpClass)}
        /*style={{ height: this.props.height }}*/
      >
        <CommentPost type={type} currentResource={currentResource} />

        <CommentList type={type} currentResource={currentResource} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth
});

const mapDispatchToProps = dispatch => ({
  fetchComments: (objectType, objectId) =>
    dispatch(fetchComments(objectType, objectId)),
  resetComments: () => dispatch(resetComments())
  //fetchTopicComments: data => dispatch(fetchTopicComments(data))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Comments);



// WEBPACK FOOTER //
// ./src/components/Reveal/Comments/index.js